import {
	ResourceType,
	type ReferenceTable as PersistenceReferenceTable
} from '@semanticedge/persistence-service-noheaders-client/src'

export type ReferenceTableRow = Record<string, string | number | boolean | null>

export const REFERENCE_TABLE_CLASS_NAME = 'ReferenceTable' as const

export type ReferenceTable = Omit<PersistenceReferenceTable, 'data'> & {
	data?: ReferenceTableRow[]
	resourceType?: typeof ResourceType.ReferenceTable
}

export type OpenApiTypedValue = {
	'@class': string
	value: unknown
}

export type OutgoingCustomDataType = {
	'@class': string
	[columnName: string]: OpenApiTypedValue | string
}
